/**
 * Copyright (c) 2018-present clchart Contributors.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// 以下是 一组控制按钮的 的实体定义  --- 画线类

// 实际上就是获取某种类型数据，然后横坐标 0 开始排序，永远是数值型，但显示出什么要到对应的数组中找
// 纵坐标根据数据类型，计算最大最小值，然后根据画线类型画出数据线，所有的不同全部在ClChart中处理

import {
    _fillRect,
    _drawRect,
    _setLineWidth,
    _getTxtWidth,
    _drawBegin,
    _drawHline,
    _drawTxt,
    _drawEnd,
} from './cl.draw'
import {
    initCommonInfo,
    checkLayout,
} from './cl.chart.init'
import {
    CHART_LAYOUT
} from '../cl.chart.res'
import {
    updateJsonOfDeep,
    copyJsonOfDeep,
    offsetRect,
    inRect,
} from '../cl.utils'

import ClChartButton from './cl.chart.button'

/**
 * Class representing ClChartCtrls
 * @export
 * @class ClChartCtrls
 */
export default class ClChartCtrls {
    /**

     * Creates an instance of ClChartCtrls.
     * @param {Object} father line chart's parent context
     */
    constructor(father) {
        initCommonInfo(this, father)
    }
    /**
     * init line
     * @param {Object} cfg line's config
     * @param {any} callback initialized callback
     * @memberof ClChartCtrls
     */
    init(cfg, callback) {
        this.callback = callback

        this.rectMain = cfg.rectMain || {
            left: 0,
            top: 0,
            width: 400,
            height: 25
        }

        this.layout = updateJsonOfDeep(cfg.layout, CHART_LAYOUT)
        this.config = copyJsonOfDeep(cfg.config)
        // 这里直接赋值是因为外部已经设置好了配置才会开始初始化
        this.ctrls = cfg.config.ctrls || []

        this.drawInfo = {
            selectIndex: 0, // 当前索引
            curBeginIndex: 0, // 当前开始索引
            maxBeginIndex: -1, // 最大的开始索引
            pageCtrls: -1, // 每页控制数
            pageCount: -1, // 全部页数 pageCount > 1 表示需要显示翻页按钮
            ctrlNums: this.ctrls.length,
        }
        if (this.config.selectIndex !== undefined) {
            this.drawInfo.selectIndex = this.config.selectIndex
        }
        // console.log(this.name, this.drawInfo.selectIndex);
        // 下面对配置做一定的校验
        this.checkConfig()
        // 再做一些初始化运算，下面的运算范围是初始化设置后基本不变的数据
        this.setPublicRect()
        // 初始化按钮
        this.childCharts = {}
        if (!this.config.hidepage) {
            this.createPages()
        }
    }
    checkConfig() { // 检查配置有冲突的修正过来
        checkLayout(this.layout)
        this.font = this.config.font || this.layout.title.font
        this.pixel = this.config.pixel * this.scale || this.layout.title.pixel
        this.chWidth = _getTxtWidth(this.context, 'W', this.font, this.pixel)
        this.drawInfo.spaceY = this.config.spaceY * this.scale || this.layout.title.spaceY
        this.drawInfo.spaceX = this.config.spaceX * this.scale || this.layout.title.spaceX
        if (this.config.style === 'vertical') {
            this.drawInfo.ctrlHeight = this.pixel + 2 * this.scale
            if (this.config.title) {
                if (this.config.title.height === undefined) {
                    this.config.title.height = this.drawInfo.ctrlHeight
                }
                else {
                    this.config.title.height *= this.scale
                }
            }
        } else {
            const maxchs = this.config.maxchs || 6
            this.drawInfo.ctrlWidth = this.chWidth * maxchs + 2 * this.scale
            if (this.config.title && this.config.title.width !== undefined) {
                this.config.title.width *= this.scale
            }
        }
    }
    /**
     * set public rect
     * @memberof ClChartCtrls
     */
    setPublicRect() { // 计算所有矩形区域
        // rectChart 画图区
        // rectTitle rectMess
        // rectAxisX
        // rectPage
        // rectAxisYLeft rectAxisYRight
        // rectGridLine 坐标线区域

        this.rectChart = offsetRect(this.rectMain, this.layout.margin)
        // console.log(this.rectChart);
        this.rectChart = offsetRect(this.rectChart, this.layout.offset)
        // console.log(this.rectChart);
        this.rectTitle = {
            left: this.rectChart.left,
            top: this.rectChart.top,
            width: 0,
            height: 0
        }
        this.rectPage = {
            left: this.rectChart.left,
            top: this.rectChart.top,
            width: 0,
            height: 0
        }
        // 这里设置 drawInfo 

        if (this.config.style === 'vertical') {

            if (this.config.title !== undefined) {
                this.rectTitle = {
                    left: this.rectChart.left,
                    top: this.rectChart.top,
                    width: this.rectChart.width,
                    height: this.config.title.height
                }
            }
            this.drawInfo.pageCtrls = Math.floor((this.rectChart.height - this.rectTitle.height) / (this.drawInfo.ctrlHeight + 2 * this.drawInfo.spaceY));
            this.drawInfo.pageCount = Math.round(this.drawInfo.ctrlNums / this.drawInfo.pageCtrls);
            if (this.drawInfo.pageCount * this.drawInfo.pageCtrls < this.drawInfo.ctrlNums) {
                this.drawInfo.pageCount++;
            }

            if (this.drawInfo.pageCount > 1) {
                if (!this.config.hidepage) {
                    this.rectPage = {
                        left: this.rectChart.left,
                        top: this.rectChart.top + this.rectChart.height - this.layout.scroll.size,
                        width: this.rectChart.width,
                        height: this.layout.scroll.size
                    }
                }
            }
            this.rectChart = {
                left: this.rectChart.left,
                top: this.rectChart.top + this.rectTitle.height,
                width: this.rectChart.width,
                height: this.rectChart.height - this.rectTitle.height - this.rectPage.height,
            }
            this.drawInfo.spaceY = (this.rectChart.height - this.drawInfo.pageCtrls * this.drawInfo.ctrlHeight) / (2 * this.drawInfo.pageCtrls)
        } else {
            let txtWidth = 0
            if (this.config.title !== undefined) {
                if (this.config.title.width !== undefined) {
                    txtWidth = this.config.title.width - this.scale
                }
                else {
                    txtWidth = _getTxtWidth(this.context, this.config.title.label, this.font, this.pixel) + 2 * this.drawInfo.spaceX
                }
                this.rectTitle = {
                    left: this.rectChart.left,
                    top: this.rectChart.top,
                    width: txtWidth,
                    height: this.rectChart.height,
                }
            }
            let ctrlWidth = this.rectChart.width - txtWidth
            this.drawInfo.pageCtrls = Math.floor((ctrlWidth) / (this.drawInfo.ctrlWidth + 2 * this.drawInfo.spaceX));
            this.drawInfo.pageCount = Math.round(this.drawInfo.ctrlNums / this.drawInfo.pageCtrls);
            if (this.drawInfo.pageCount * this.drawInfo.pageCtrls < this.drawInfo.ctrlNums) {
                this.drawInfo.pageCount++;
            }

            if (this.drawInfo.pageCount > 1) {
                const moveW = (this.rectChart.height + 2 * this.scale) * 2
                if (!this.config.hidepage) {
                    this.rectPage = {
                        left: this.rectChart.left + this.rectChart.width - moveW,
                        top: this.rectChart.top,
                        width: moveW,
                        height: this.rectChart.height,
                    }
                }
            }
            this.rectChart = {
                left: this.rectChart.left + txtWidth,
                top: this.rectChart.top,
                width: ctrlWidth - this.rectPage.width,
                height: this.rectChart.height,
            }
            this.drawInfo.spaceX = (ctrlWidth - this.rectPage.width - this.drawInfo.pageCtrls * this.drawInfo.ctrlWidth) / (2 * this.drawInfo.pageCtrls)
            // console.log(this.drawInfo.pageCtrls, this.drawInfo.spaceX, this.drawInfo.ctrlWidth);
        }
        // console.log(this.rectMain, this.rectTitle, this.rectChart, this.rectPage);
        this.drawInfo.maxBeginIndex = this.drawInfo.ctrlNums - this.drawInfo.pageCtrls
        if (this.drawInfo.maxBeginIndex < 0) {
            this.drawInfo.maxBeginIndex = 0
        }
        this.drawReady()
        // console.log(this.drawInfo.selectIndex, this.drawInfo.curBeginIndex);
    }
    drawReady() {
        if ((this.drawInfo.selectIndex > this.drawInfo.pageCtrls - 1) || this.drawInfo.selectIndex < this.drawInfo.curBeginIndex) {
            this.drawInfo.curBeginIndex = Math.max(0, this.drawInfo.selectIndex - Math.floor(this.drawInfo.pageCtrls / 2))
            this.drawInfo.curBeginIndex = Math.min(this.drawInfo.curBeginIndex, this.drawInfo.maxBeginIndex)
        }
        // console.log(this.drawInfo.selectIndex, this.drawInfo.curBeginIndex);
        
    }
    /**
     * set ctrls
     * @memberof ClChartCtrls
     */
    createPages() {
        if (this.drawInfo.pageCount < 2) {
            return
        }
        // console.log(this.rectPage);
        if (this.config.style === 'vertical') {
            // 4 个按钮
            let ww = this.rectPage.width / 4
            let xx = this.rectPage.left 
            {
                const chart = new ClChartButton(this)
                chart.name = 'ups'
                this.childCharts[chart.name] = chart
                chart.init({
                        rectMain: {
                            left: xx,
                            top: this.rectPage.top,
                            width: ww,
                            height: this.rectPage.height
                        },
                        info: { // 放大
                            clickName: chart.name,
                            drawMethod: chart.name,
                        },
                    },
                    result => {
                        this.changeIndex(-1 * this.drawInfo.pageCtrls)
                    })
                xx += ww
            } 
            {
                const chart = new ClChartButton(this)
                chart.name = 'up'
                this.childCharts[chart.name] = chart
                chart.init({
                        rectMain: {
                            left: xx,
                            top: this.rectPage.top,
                            width: ww,
                            height: this.rectPage.height
                        },
                        info: { // 放大
                            clickName: chart.name,
                            drawMethod: chart.name,
                        },
                    },
                    result => {
                        this.changeIndex(-1)
                    })
                xx += ww
            } 
            {
                const chart = new ClChartButton(this)
                chart.name = 'down'
                this.childCharts[chart.name] = chart
                chart.init({
                        rectMain: {
                            left: xx,
                            top: this.rectPage.top,
                            width: ww,
                            height: this.rectPage.height
                        },
                        info: { // 放大
                            clickName: chart.name,
                            drawMethod: chart.name,
                        },
                    },
                    result => {
                        this.changeIndex(1)
                    })
                xx += ww
            } 
            {
                const chart = new ClChartButton(this)
                chart.name = 'downs'
                this.childCharts[chart.name] = chart
                chart.init({
                        rectMain: {
                            left: xx,
                            top: this.rectPage.top,
                            width: ww,
                            height: this.rectPage.height
                        },
                        info: { // 放大
                            clickName: chart.name,
                            drawMethod: chart.name,
                        },
                    },
                    result => {
                        this.changeIndex(this.drawInfo.pageCtrls)
                    })
                xx += ww
            }
        } else {
            // 2 个按钮
            let ww = this.rectPage.width / 2
            let xx = this.rectPage.left 
            {
                const chart = new ClChartButton(this)
                chart.name = 'left'
                this.childCharts[chart.name] = chart
                chart.init({
                        rectMain: {
                            left: xx,
                            top: this.rectPage.top,
                            width: ww,
                            height: this.rectPage.height
                        },
                        info: { // 放大
                            clickName: chart.name,
                            drawMethod: chart.name,
                        },
                    },
                    result => {
                        this.changeIndex(-1)
                    })
                xx += ww
            } 
            {
                const chart = new ClChartButton(this)
                chart.name = 'right'
                this.childCharts[chart.name] = chart
                chart.init({
                        rectMain: {
                            left: xx,
                            top: this.rectPage.top,
                            width: ww,
                            height: this.rectPage.height
                        },
                        info: { // 放大
                            clickName: chart.name,
                            drawMethod: chart.name,
                        },
                    },
                    result => {
                        this.changeIndex(1)
                    })
                xx += ww
            }
        }

    }
    /**
     * draw child charts
     * @memberof ClChartCtrls
     */
    drawPages() {
        let hotchart
        for (const name in this.childCharts) {
            if (!this.childCharts[name].focused) {
                this.childCharts[name].onPaint()
            } else {
                hotchart = this.childCharts[name]
            }
        }
        if (hotchart) hotchart.onPaint()
    }
    /**
     * clear chart
     * @memberof ClChartCtrls
     */
    drawClear() {
        _fillRect(this.context, this.rectMain.left, this.rectMain.top, this.rectMain.width, this.rectMain.height, this.color.back)
        _drawBegin(this.context, this.color.grid)
        _drawRect(this.context, this.rectMain.left, this.rectMain.top, this.rectMain.width, this.rectMain.height)
        _drawEnd(this.context)
    }
    drawTitle() {
        const center = {
            xx: Math.round(this.rectTitle.width / 2),
            yy: Math.floor(this.rectTitle.height / 2),
            offset: 4 * this.scale
        }
        let minfos = 0;
        let spaceX = this.scale
        const values = this.config.title.value;
        if (values && values.length > 0) {
            minfos = 4 + values.length + 2
            let curWidth = _getTxtWidth(this.context, this.config.title.label, this.font, this.pixel) 
            for (let index = 0; index < values.length; index++) {
                curWidth += _getTxtWidth(this.context, values[index].label, this.font, this.pixel) 
            }
            spaceX = (this.rectTitle.width - curWidth) / minfos
        } 
        // console.log(minfos, spaceX);
        
        if (this.config.style === 'vertical') {
            _drawBegin(this.context, this.color.button)
            _fillRect(this.context, this.rectTitle.left, this.rectTitle.top, this.rectTitle.width, this.rectTitle.height, this.color.baktxt)
            _drawRect(this.context, this.rectTitle.left, this.rectTitle.top, this.rectTitle.width, this.rectTitle.height)
            _drawEnd(this.context)
            if (minfos == 0) {
                _drawTxt(this.context, this.rectTitle.left + center.xx, this.rectTitle.top + center.yy, this.config.title.label,
                    this.font, this.pixel, this.color.btntxt, {
                        x: 'center',
                        y: 'middle'
                    })
            }
            else {
                let xx = this.rectTitle.left + 3 * spaceX
            
                _drawTxt(this.context, xx, this.rectTitle.top + center.yy, this.config.title.label,
                    this.font, this.pixel, this.color.btntxt, {
                        y: 'middle'
                    })
                xx += _getTxtWidth(this.context, this.config.title.label, this.font, this.pixel)  + 3 * spaceX
                for (let index = 0; index < values.length; index++) {
                    let clr = this.color[values[index].color] || txtclr         
                    _drawTxt(this.context, xx, this.rectTitle.top + center.yy, values[index].label,
                        this.font, this.pixel, clr, {
                            y: 'middle'
                        })
                    xx += _getTxtWidth(this.context, values[index].label, this.font, this.pixel) + spaceX
                }
            }
        }
        else {
            _drawBegin(this.context, this.color.button)
            _fillRect(this.context, this.rectTitle.left, this.rectTitle.top, this.rectTitle.width, this.rectTitle.height, this.color.baktxt)
            _drawRect(this.context, this.rectTitle.left, this.rectTitle.top, this.rectTitle.width, this.rectTitle.height)
            _drawEnd(this.context)
            // console.log(this.rectTitle.left + center.xx, this.rectTitle.top + center.yy, this.config.title.label);
            _drawTxt(this.context, this.rectTitle.left + center.xx, this.rectTitle.top + center.yy, this.config.title.label,
                this.font, this.pixel, this.color.btntxt, {
                    x: 'center',
                    y: 'middle'
                })

        }
    }
    drawCtrl(ridx, rect, selected) {
        let txtclr = this.color.btntxt
        if (selected) {
            txtclr = this.color.btnhot
        }
        if (this.drawInfo.selectIndex == -1) {
            if (this.ctrls[ridx].color !== undefined) {
                txtclr = this.ctrls[ridx].color
            }
        }
        // console.log(ridx, rect);
        _drawBegin(this.context, this.color.button);
        _fillRect(this.context, rect.left, rect.top, rect.width, rect.height, this.color.back)
        _drawRect(this.context, rect.left, rect.top, rect.width, rect.height)

        const center = {
            xx: Math.round(rect.width / 2),
            yy: Math.floor(rect.height / 2),
            offset: 4 * this.scale
        }
        let spaceX = this.scale
        if (this.ctrls[ridx].value !== undefined && this.ctrls[ridx].value.length > 0) {
            
            let spaceX = (rect.width - this.drawInfo.maxTWidth - this.drawInfo.maxVWidth) / ((this.ctrls[ridx].value.length + 1) + 2)
            
            let xx = rect.left + spaceX
            // console.log(spaceX, xx, this.drawInfo.maxTWidth, this.drawInfo.maxVWidth);
            
            _drawTxt(this.context, xx, rect.top + center.yy, this.ctrls[ridx].label,
                this.font, this.pixel, txtclr, {
                    x: 'left',
                    y: 'middle'
                })
            xx += this.drawInfo.maxTWidth + 2 * spaceX
            for (let index = 0; index < this.ctrls[ridx].value.length; index++) {
                let clr = this.color[this.ctrls[ridx].value[index].color] || txtclr         
                let align = 'left'
                if (this.ctrls[ridx].value[index].align !== undefined) {
                    align = this.ctrls[ridx].value[index].align
                }
                _drawTxt(this.context, xx, rect.top + center.yy, this.ctrls[ridx].value[index].label,
                    this.font, this.pixel, clr, {
                        x: align,
                        y: 'middle'
                    })
                xx += this.drawInfo.maxVarW[index] + spaceX
                // _getTxtWidth(this.context, this.ctrls[ridx].value[index].label, this.font, this.pixel) + spaceX
            }

        } else {
            // console.log(this.ctrls[ridx], ridx);
            let showTxt = this.ctrls[ridx].label
            while (_getTxtWidth(this.context, showTxt, this.font, this.pixel) > rect.width - 2 * this.scale) {
                showTxt = showTxt.slice(0, -2) + '.';
            }
            let align = 'center'
            if (this.ctrls[ridx].align === 'left') {
                // center.xx = 2 * this.scale
                let spaceX = (rect.width - this.drawInfo.maxTWidth) / 2
                center.xx = rect.left + spaceX
                align = 'left'
            }
            
            _drawTxt(this.context, rect.left + center.xx, rect.top + center.yy, showTxt,
                this.font, this.pixel, txtclr, {
                    x: align,
                    y: 'middle'
                })
        }
        _drawEnd(this.context);
    }
    drawCtrls() {
        // console.log(this.drawInfo.selectIndex, this.drawInfo.curBeginIndex);
        let count = this.drawInfo.curBeginIndex + this.drawInfo.pageCtrls
        count = Math.min(count, this.drawInfo.ctrlNums)
        
        this.drawInfo.maxTWidth = 0
        this.drawInfo.maxVWidth = 0
        this.drawInfo.maxVarW = []
        for (let index = this.drawInfo.curBeginIndex; index < count; index++) {
            this.drawInfo.maxTWidth = Math.max(this.drawInfo.maxTWidth, _getTxtWidth(this.context, this.ctrls[index].label, this.font, this.pixel))
            if (this.ctrls[index].value !== undefined) {
                let maxVWidth = 0
                if (this.ctrls[index].value !== undefined) {
                    for (let vindex = 0; vindex < this.ctrls[index].value.length; vindex++) {
                        const curW = _getTxtWidth(this.context, this.ctrls[index].value[vindex].label, this.font, this.pixel)
                        while (vindex + 1 > this.drawInfo.maxVarW.length) {
                            this.drawInfo.maxVarW.push(0)
                        }
                        this.drawInfo.maxVarW[vindex] = Math.max(this.drawInfo.maxVarW[vindex], curW)      
                        maxVWidth += this.drawInfo.maxVarW[vindex]
                    }
                }
                if (maxVWidth > 0) {
                    this.drawInfo.maxVWidth = Math.max(this.drawInfo.maxVWidth, maxVWidth)
                }
            }
        }
        // if (this.config.style === 'vertical') {
        //     for (let index = this.drawInfo.curBeginIndex; index < count; index++) {
        //         let maxVWidth = 0
        //         if (this.ctrls[index].value !== undefined) {
        //             for (let vindex = 0; vindex < this.ctrls[index].value.length; vindex++) {
        //                 maxVWidth += _getTxtWidth(this.context, this.ctrls[index].value[vindex].label, this.font, this.pixel)
        //             }
        //         }
        //         if (maxVWidth > 0) {
        //             this.drawInfo.maxVWidth = Math.max(this.drawInfo.maxVWidth, maxVWidth)
        //         }
        //     }
        // }

        for (let index = this.drawInfo.curBeginIndex; index < count; index++) {
            const curidx = index - this.drawInfo.curBeginIndex
            if (this.config.style === 'vertical') {
                let y1 = this.rectChart.top + curidx * (this.drawInfo.ctrlHeight + 2 * this.drawInfo.spaceY)
                let hh = (this.drawInfo.ctrlHeight + 2 * this.drawInfo.spaceY)
                this.drawCtrl(index, {
                    left: this.rectChart.left,
                    top: y1,
                    width: this.rectChart.width,
                    height: hh
                }, this.drawInfo.selectIndex === index)
            } else {
                let x1 = this.rectChart.left + curidx * (this.drawInfo.ctrlWidth + 2 * this.drawInfo.spaceX)
                let ww = (this.drawInfo.ctrlWidth + 2 * this.drawInfo.spaceX)

                this.drawCtrl(index, {
                    left: x1,
                    top: this.rectChart.top,
                    width: ww,
                    height: this.rectChart.height,
                }, this.drawInfo.selectIndex === index)
            }
        }
    }
    /**
     * draw all the layers contained in this area
     * @memberof ClChartCtrls
     */
    onPaint() {

        _setLineWidth(this.context, this.scale)
        // console.log(this.name, this.drawInfo.selectIndex, this.drawInfo.curBeginIndex);
        
        this.drawClear() // 清理画图区

        // this.drawReady()

        if (this.config.title !== undefined) {
            this.drawTitle()
        }
        if (this.drawInfo.pageCount > 1) {
            this.drawPages()
        }
        
        // 画所有的控制
        this.drawCtrls()

    }
    changeCtrls(ctrls) {
        this.ctrls = ctrls
        this.drawCtrls()
    }
    changeIndex(moveIndex) {
        moveIndex = Math.floor(moveIndex)
        // console.log(moveIndex, this.drawInfo);
        if (moveIndex < 0) {
            if (this.drawInfo.curBeginIndex > 0) {
                this.drawInfo.curBeginIndex += moveIndex
                if (this.drawInfo.curBeginIndex < 0) {
                    this.drawInfo.curBeginIndex = 0
                }
            }
        }
        if (moveIndex > 0) {
            if (this.drawInfo.curBeginIndex < this.drawInfo.maxBeginIndex) {
                this.drawInfo.curBeginIndex += moveIndex
                if (this.drawInfo.curBeginIndex > this.drawInfo.maxBeginIndex) {
                    this.drawInfo.curBeginIndex = this.drawInfo.maxBeginIndex
                }
            }
        }
        // console.log(this.drawInfo.curBeginIndex);
        this.onPaint()
    }
    onMouseWheel(event) {
        // console.log('onMouseWheel', this.name, event.deltaX, event.deltaY, Math.abs(event.deltaX), Math.abs(event.deltaY))
        if (this.config.style === 'vertical') {
            if (Math.abs(event.deltaY) > 0) {
                let moveI = Math.abs(event.deltaY) > 30 ? event.deltaY : (Math.abs(event.deltaY) > 10 ? event.deltaY / 10 : (event.deltaY > 0 ? 1 : -1))
                this.changeIndex(moveI)
            }
        } else {
            if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) {
                if (Math.abs(event.deltaX) > 0) {
                    let moveI = Math.abs(event.deltaX) > 10 ? event.deltaX / 10 : (event.deltaX > 1 ? 1 : event.deltaX < -1 ? -1 : 0)
                    this.changeIndex(moveI)
                }
            }
        }
    }
    getMouseInIndex(mousePos) {
        if (this.config.style === 'vertical') {
            if ((mousePos.y > this.rectChart.top) && (mousePos.y < this.rectChart.top + this.rectChart.height)) {
                let moveY = this.rectChart.top;
                for (let i = 0; i < this.drawInfo.pageCtrls; i++) {
                    const stepY = this.drawInfo.ctrlHeight + 2 * this.drawInfo.spaceY;
                    if (mousePos.y > (moveY) && mousePos.y < (moveY + stepY)) {
                        return i
                    }
                    moveY += stepY;
                    if (moveY > this.rectChart.top + this.rectChart.height) {
                        break
                    }
                }
            }
        } else {
            if ((mousePos.x > this.rectChart.left) && (mousePos.x < this.rectChart.left + this.rectChart.width)) {
                let moveX = this.rectChart.left;
                for (let i = 0; i < this.drawInfo.pageCtrls; i++) {
                    const stepX = this.drawInfo.ctrlWidth + 2 * this.drawInfo.spaceX;
                    if (mousePos.x > (moveX) && mousePos.x < (moveX + stepX)) {
                        return i
                    }
                    moveX += stepX;
                    if (moveX > this.rectChart.left + this.rectChart.width) {
                        break
                    }
                }
            }
        }
        return -1
    }

    drawSelected(ridx, selected) {
        if (ridx < 0) {
            return
        }
        // console.log(ridx, this.drawInfo.curBeginIndex);
        
        const curidx = ridx - this.drawInfo.curBeginIndex
        if (curidx < 0 || curidx > this.drawInfo.ctrlNums - 1) {
            return
        }

        if (this.config.style === 'vertical') {
            let y1 = this.rectChart.top + curidx * (this.drawInfo.ctrlHeight + 2 * this.drawInfo.spaceY)
            let hh = (this.drawInfo.ctrlHeight + 2 * this.drawInfo.spaceY)
            this.drawCtrl(ridx, {
                left: this.rectChart.left,
                top: y1,
                width: this.rectChart.width,
                height: hh
            }, selected)
        } else {
            let x1 = this.rectChart.left + curidx * (this.drawInfo.ctrlWidth + 2 * this.drawInfo.spaceX)
            let ww = (this.drawInfo.ctrlWidth + 2 * this.drawInfo.spaceX)

            this.drawCtrl(ridx, {
                left: x1,
                top: this.rectChart.top,
                width: ww,
                height: this.rectChart.height,
            }, selected)
        }
    }
    changeSelectIndex(newIndex) {
        console.log(newIndex, this.drawInfo.selectIndex, this.drawInfo.curBeginIndex, this.drawInfo.ctrlNums);
        if (this.drawInfo.selectIndex == -1) {
            this.drawInfo.selectIndex = newIndex
            this.drawReady()
            this.onPaint()
        }
        else {
            if (newIndex >= 0 && newIndex < this.drawInfo.ctrlNums) {
                this.drawSelected(this.drawInfo.selectIndex, false)
                this.drawInfo.selectIndex = newIndex
                // console.log(this.drawInfo.selectIndex >= this.drawInfo.curBeginIndex, this.drawInfo.selectIndex < this.drawInfo.curBeginIndex + this.drawInfo.pageCtrls);
                if (this.drawInfo.selectIndex >= this.drawInfo.curBeginIndex && this.drawInfo.selectIndex < this.drawInfo.curBeginIndex + this.drawInfo.pageCtrls) {
                    this.drawSelected(this.drawInfo.selectIndex, true)
                }
                else {
                    this.drawReady()
                    this.onPaint()
                }
            }
        }
    }
    onClick(event) {
        console.log('onClick', this.name, this.drawInfo.selectIndex, this.drawInfo.curBeginIndex, this.drawInfo.ctrlNums);
        
        if (inRect(this.rectTitle, event.mousePos)) {
            const result = {
                event: 'btndown',
                value: 'title',
                selectIndex: -1,
            }
            this.callback(result)
            if (result.cancel) {
                result.selectIndex = this.drawInfo.selectIndex
            }
            if (result.selectIndex === -1) {
                this.drawInfo.selectIndex = -1
            }
            // console.log(nIndex, this.drawInfo.selectIndex);
            if (result.selectIndex !== this.drawInfo.selectIndex) {
                this.drawReady()
                this.onPaint()
            }
        }
        const clickIndex = this.getMouseInIndex(event.mousePos)
        const newIndex = clickIndex + this.drawInfo.curBeginIndex
        if (newIndex !== this.drawInfo.selectIndex) {
            if (newIndex >= 0 && newIndex < this.drawInfo.ctrlNums) {
                this.changeSelectIndex(newIndex)
                console.log('change', this.name, this.drawInfo.selectIndex, this.drawInfo.curBeginIndex, this.drawInfo.ctrlNums);
        
                this.callback({
                    event: 'btndown',
                    value: this.ctrls[this.drawInfo.selectIndex].clickValue,
                    selectIndex: this.drawInfo.selectIndex,
                })
            }
        }
        else {
            let value = 'title'
            if (this.drawInfo.selectIndex >= 0) {
                value = this.ctrls[this.drawInfo.selectIndex].clickValue
            }
            this.callback({
                event: 'onclick',
                value: value,
                selectIndex: this.drawInfo.selectIndex,
            })
        }
    }
}